import Vue from 'vue/dist/vue.esm'
import template from './district_next_step_report_template.slim'
import moment from 'moment'
import { seriesData, mergeCounts } from '../commonChartFunctions';
import chartFilterable from '../../mixins/chart_filterable';
import chartResponsiveWidth from '../../mixins/chart_responsive_width'

Vue.component('district_next_step_report', {
  mixins: [template, chartResponsiveWidth, chartFilterable],
  props: ['school_year_label', 'year_info', 'report_date', 'section'],
  data() {
    const nextStepTerm = this.$nextStepTerm();
    const nextStepsTerm = this.$nextStepsTerm();
    return {
      nextStepTerm,
      nextStepsTerm,
      startDate: '',
      endDate: '',
      currentFilterType: 'whole_year',
      chartDataCreated: {},
      chartDataCompleted: {},
      series: [{
          name: 'Created',
          data: []
        },
        {
          name: 'Completed',
          data: []
        }],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: true
          },
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: `District ${nextStepsTerm}`,
            style: {
              color: '#949494'
            }
          },
          forceNiceScale: true
        },
        grid: {
          row: {
            colors: ['#FFFFFF', '#F3F3F3']
          }
        }
      }
    }
  },
  mounted() {
      if (!this.filters.dateRange) {
        this.wholeYearRangeClicked();
      }
      this.updateDataAttributes();
  },
  watch: {
    currentFilterType: 'updateDataAttributes'
  },
  computed: {
    createdNextSteps: function() {
      return _.reduce(mergeCounts(this.chartDataCreated), (sum, val, key) => {
        if (moment(key).isBetween(this.startDate, this.endDate, null, "[]")) {
          return sum + val
        } else {
          return sum
        }
      }, 0)
    },
    completedNextSteps: function() {
      return _.reduce(mergeCounts(this.chartDataCompleted), (sum, val, key) => {
        if (moment(key).isBetween(this.startDate, this.endDate, null, "[]")) {
          return sum + val
        } else {
          return sum
        }
      }, 0)
    },
  },
  methods: {
    pluralizeNextSteps(count) {
      return count === 1 ? this.nextStepTerm : this.nextStepsTerm;
    },
    sevenDayRangeClicked: function() {
      this.setDayRange(7, '7_days');
    },
    thirtyDayRangeClicked: function() {
      this.setDayRange(30, '30_days');
    },
    wholeYearRangeClicked: function() {
      this.startDate = moment(`${this.year_info.school_start_date}`);
      this.endDate = moment().endOf('day');
      this.currentFilterType = 'whole_year';
      this.setChartZoom();
    },
    setDayRange: function(day, filterType) {
      this.startDate = moment().subtract(day, "days").startOf("day");
      this.endDate = moment().subtract(1, "days").endOf("day");
      this.currentFilterType = filterType;
      this.setChartZoom();
    },
    setChartZoom: function() {
      this.$refs.apexChart?.zoomX(this.startDate?.valueOf(), this.endDate?.valueOf());
    },
    updateDataAttributes: function() {
      const el = this.$el;
      if (!el) return;

      el.setAttribute('data-filter-type', this.currentFilterType);
    },
    applyData: function(data) {
      this.chartDataCreated = data.created;
      this.chartDataCompleted = data.completed;
      this.applyDateRangeBounds();
      this.$refs.apexChart.updateSeries([{
          name: 'Created',
          data: seriesData(mergeCounts(data.created))
        },
        {
          name: 'Completed',
          data: seriesData(mergeCounts(data.completed))
        }]);
      this.$nextTick(this.setChartZoom);
    }
  }
});
